import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.85, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

const line = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease: EASE, delay: i * 0.12 } }),
};

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, as: Tag = "h2", delay = 0 }) => {
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } };
  const MotionTag = motion[Tag];
  return (
    <MotionTag className={className} initial="hidden" {...trigger} transition={{ delayChildren: delay }}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className={`block ${typeof l === "object" && l.className ? l.className : lineClassName}`} variants={line} custom={i + delay * 8}>
            {typeof l === "object" ? l.text : l}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};
